import { Dropdown } from "react-bootstrap";
import { ReactComponent as OutlineMicrophonePrimary } from "assets/svg/outline-microphone-primary.svg";
import { ReactComponent as OutlineChevronDown } from "assets/svg/outline-chevron-down.svg";
import { ReactComponent as OutlineCheckPrimary } from "assets/svg/outline-check-primary.svg";
import styles from "./MicOptions.module.scss";
import availableMediaDevicesQueryOptions from "components/video-chat/availableMediaDevicesQueryOptions";
import { useQuery } from "@tanstack/react-query";
import AudioInputLevelHorizontal from "components/video-chat/select-devices/AudioInputLevelHorizontal";
import { isMobileOnly } from "react-device-detect";

function sanitizeDeviceLabel(label: string): string {
  return label.replace(/\s*\([0-9a-fA-F]{4}:[0-9a-fA-F]{4}\)\s*$/, "");
}

interface MicOptionsProps {
  micMediaStreamRef: React.MutableRefObject<MediaStream | null>;
  audioInputDeviceId: string;
  onAudioInputChange?: (deviceId: string) => void;
  hasMediaAccess: boolean;
}

const MicOptions = ({
  micMediaStreamRef,
  audioInputDeviceId,
  onAudioInputChange = () => {},
  hasMediaAccess,
}: MicOptionsProps) => {
  const availableMediaDevicesQuery = useQuery(
    availableMediaDevicesQueryOptions(hasMediaAccess && !isMobileOnly),
  );

  const currentAudioInputDeviceLabel = sanitizeDeviceLabel(
    availableMediaDevicesQuery.data?.audioInputDevices.find(
      (device) => device.deviceId === audioInputDeviceId,
    )?.label ||
      availableMediaDevicesQuery.data?.audioInputDevices[0]?.label ||
      "Default",
  );

  return (
    <div className={styles.setting}>
      <Dropdown className={styles.settingDropdown}>
        <Dropdown.Toggle variant="link" bsPrefix={styles.dropdownToggle}>
          <OutlineMicrophonePrimary />
          <span className={styles.dropdownToggleTextLabel}>
            {currentAudioInputDeviceLabel}
          </span>
          <OutlineChevronDown />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {availableMediaDevicesQuery.data?.audioInputDevices.map(
            (device, i, arr) => (
              <Dropdown.Item
                key={device.deviceId}
                onClick={() => {
                  onAudioInputChange?.(device?.deviceId);
                }}
              >
                {device.deviceId === audioInputDeviceId || arr.length === 1 ? (
                  <OutlineCheckPrimary />
                ) : (
                  <div style={{ width: 24 }} />
                )}
                {sanitizeDeviceLabel(device.label || `Input ${i + 1}`)}
              </Dropdown.Item>
            ),
          )}
          <Dropdown.Item className={styles.dropdownItemMicLevel}>
            <OutlineMicrophonePrimary />
            <AudioInputLevelHorizontal
              mediaStreamTrack={micMediaStreamRef?.current?.getTracks()[0]}
            />
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default MicOptions;
